var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    r: 20,
    transform: "matrix(1 0 0 -1 20 20)",
    fill: "#066B35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11.2075C15.4432 11.2075 11.75 14.8311 11.75 19.3019C11.75 23.7726 15.4432 27.3962 20 27.3962C24.5568 27.3962 28.25 23.7726 28.25 19.3019C28.25 14.8311 24.5568 11.2075 20 11.2075Z",
    fill: "#066B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14C15.8953 14 15 14.8953 15 16C15 17.1047 15.8953 18 17 18C18.1047 18 19 17.1047 19 16C19 14.8953 18.1047 14 17 14Z",
    fill: "#FFE6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9622 42.2301L19.9999 48L22.0376 42.2301V29.1724C21.3733 29.2781 20.6968 29.3455 19.9999 29.3455C19.303 29.3455 18.6265 29.2781 17.9622 29.1724L17.9622 42.2301Z",
    fill: "#066B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.43e792dc02c91733c623242aa9ab028a.svg";
export { ForwardRef as ReactComponent };